import React from 'react';
import { ArrowRight, Calendar, Tag } from 'lucide-react';
import { blogPosts } from '../data/mock';

const Blog = () => {
  return (
    <section id="insights" className="py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-8">
          <span className="inline-block text-gold-600 font-semibold text-sm tracking-wider uppercase mb-4">
            Insights & Resources
          </span>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-navy-900 mb-6">
            Latest from Our Blog
          </h2>
          <p className="text-base text-gray-600 leading-relaxed">
            Expert insights and strategies to help your business thrive
          </p>
        </div>

        {/* Blog Grid */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-5">
          {blogPosts.map((post) => (
            <article
              key={post.id}
              className="panel-flair group bg-white rounded-2xl overflow-hidden border-2 border-slate-200/70 hover:border-gold-400 transition-all duration-500 hover:-translate-y-1"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-900/40 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-gold-500 text-navy-900 rounded-full text-xs font-semibold">
                    <Tag className="w-3 h-3" />
                    {post.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-2 text-gray-500 text-sm mb-4">
                  <Calendar className="w-4 h-4" />
                  {post.date}
                </div>

                <h3 className="text-lg font-bold text-navy-900 mb-3 group-hover:text-gold-600 transition-colors line-clamp-2">
                  {post.title}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                  {post.excerpt}
                </p>

                <a
                  href="#"
                  className="inline-flex items-center text-gold-600 font-semibold text-sm hover:text-gold-700 transition-colors"
                >
                  Read More
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </a>
              </div>
            </article>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center mt-12">
          <a
            href="#"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gray-100 hover:bg-gray-200 text-navy-900 font-semibold rounded-full transition-colors"
          >
            View All Articles
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Blog;
